{"id":"Carousel","prefabs":{"default":{"children":[{"component":"Carousel","options":"options:*"}]}}}